import { css } from 'styled-components';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
}

var devices = {
  mobile: "412px",
  phablet: "600px",
  tablet: "768px",
  desktop: "1024px"
};

var addToPx = function addToPx(value, add) {
  var match = value.match(/(\d+)px/);
  if (!match) return value;
  return parseInt(match[0]) + add + "px";
};

var mediaQuery = function mediaQuery(condition, breakpoint, breakpoint2) {
  var deviceCheck = devices[breakpoint] || breakpoint;

  switch (condition) {
    case ">":
      return function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          @media only screen and (min-width: ", ") {\n            ", "\n          }\n        "], ["\n          @media only screen and (min-width: ", ") {\n            ", "\n          }\n        "])), addToPx(deviceCheck, 1), css.call.apply(css, __spreadArrays([undefined], args)));
      };

    case ">=":
      return function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        @media only screen and (min-width: ", ") {\n          ", "\n        }\n      "], ["\n        @media only screen and (min-width: ", ") {\n          ", "\n        }\n      "])), deviceCheck, css.call.apply(css, __spreadArrays([undefined], args)));
      };

    case "<":
      return function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          @media only screen and (max-width: ", ") {\n            ", "\n          }\n        "], ["\n          @media only screen and (max-width: ", ") {\n            ", "\n          }\n        "])), addToPx(deviceCheck, -1), css.call.apply(css, __spreadArrays([undefined], args)));
      };

    case "<=":
      return function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        @media only screen and (max-width: ", ") {\n          ", "\n        }\n      "], ["\n        @media only screen and (max-width: ", ") {\n          ", "\n        }\n      "])), deviceCheck, css.call.apply(css, __spreadArrays([undefined], args)));
      };

    case "between":
      return function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        @media (min-width: ", ") and (max-width: ", ") {\n          ", "\n        }\n      "], ["\n        @media (min-width: ", ") and (max-width: ", ") {\n          ", "\n        }\n      "])), deviceCheck, devices[breakpoint2] || breakpoint2, css.call.apply(css, __spreadArrays([undefined], args)));
      };
  }
};

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
export { mediaQuery };